module.exports = __webpack_public_path__ + "img/IMG_9000_L_Foamcore_MockedUp.145851e3.jpg";